<template>
  <section class="store-landing-featured-wrapper">
    <div class="container xl">

      <div class="featured-cat-heading-withnav relative">
         <div class="featured-heading">
          <h2 class="is-size-4 mb-3"><span>{{ title }}</span> <!-- <router-link class="font-color" :to="{ name: 'StoreProfile', params: { business_slug: $route.params.business_slug, store_slug:$route.params.store_slug }}">View all products</router-link> --></h2> 
        </div>
        <a :class="'nav-button button-prev bg-secondary arrow-prev'+id" @click="prev">
            <img src="@/assets/img/scroll-top.svg"  />
          </a>
        <a :class="'nav-button button-next bg-secondary arrow-next'+id" @click="next">
          <img src="@/assets/img/scroll-top.svg"  />
        </a>
      </div>
     
      <div class="featured-cat-swiper">
        <swiper
          :ref="'cat_slide_'+id"
          :slides-per-view="5"
          :loop="false"
          :navigation="{
            nextEl: '.arrow-next'+id,
            prevEl: '.arrow-prev'+id,
          }"
          :initialSlide="1"
          :slidesPerGroup="2"
          :freeMode="false"
          :spaceBetween="10"
          :breakpoints="{
            3000: {
              slidesPerView: 5,
              allowTouchMove: false,
            },
            1920: {
              slidesPerView: 5,
              allowTouchMove: false,
            },
            1424: {
              slidesPerView: 5,
              allowTouchMove: false,
            },
            1104: {
              slidesPerView: 4,
              allowTouchMove: false,
            },
            991: {
              slidesPerView: 3,
              allowTouchMove: false,
            },
            800: {
              slidesPerView: 3,
              allowTouchMove: false,
            },
            768: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              allowTouchMove: true,
            },
            550: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              allowTouchMove: true,
            },
            1: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              allowTouchMove: true,
            }
          }"
          :observer="true"
          :observeParents="true"
      >
        <swiper-slide
          v-bind:key="id +'_'+index+'featured_item'" v-for="(item ,index) in productsData"
        >
          <div class="featured-cat-slide-item">
          <weed-card 
            v-if="item.product_family == 'cannabis'" 
            :callback="callback" 
            :item="item" 
          ></weed-card>

          <accessory-card 
            v-else
            :callback="callback" 
            :item="item" 
          ></accessory-card>
        </div>

        </swiper-slide>
      </swiper>
    </div>
<!--      
       <VueSlickCarousel 
        v-if="productsData.length > 0"
        v-bind="{ 
          dots:false, 
          draggable: true,  
          infinite: false, 
          arrows: false, 
          dots: false,
          slidesToShow: 5,
          slidesToScroll: 2,
          responsive: [
            {
              breakpoint: 3000,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 2,
                infinite: false,
                dots:false, 
              }
            },
            {
              breakpoint: 1920,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 2,
                infinite: false,
                dots:false, 
              }
            },
            {
              breakpoint: 1424,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 2,
                infinite: false,
                dots:false, 
              }
            },
            {
              breakpoint: 1104,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                dots:false, 
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                dots:false, 
              }
            },
           
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
                dots:false, 
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots:false, 
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots:false, 
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots:false, 
              }
            },
            {
              breakpoint: 320,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots:false, 
              }
            },
          ],
        }">
        <div  v-bind:key="id +'_'+index+'featured_item'" v-for="(item ,index) in productsData">
          <weed-card 
            v-if="item.product_family == 'cannabis'" 
            :callback="callback" 
            :item="item" 
          ></weed-card>

          <accessory-card 
            v-else
            :callback="callback" 
            :item="item" 
          ></accessory-card>
        </div>


        <template #prevArrow="">
          <a class="nav-button button-prev bg-primary">
           <img src="@/assets/img/scroll-top.svg"  />
          </a>
        </template>
        <template #nextArrow="" >
          <a class="nav-button button-next bg-primary">
            <img src="@/assets/img/scroll-top.svg"  />
          </a>
        </template>
      </VueSlickCarousel>  -->
    </div>
  </section>
</template>

<script>
import Item from '@/Components/Pages/PageComponents/StoreLanding/Item';
// import OwlCarousel from "vue-owl-carousel";
// import VueSlickCarousel from 'vue-slick-carousel';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
SwiperCore.use([Navigation, Pagination])

export default {
  components: {
    Item,
    // OwlCarousel,
    // VueSlickCarousel,
   Swiper,
    SwiperSlide,
  },
  name: "StoreLandingCategoryRow",
  props: {
    id:{
      type: String,
    },
    title:{
      type: String,
    },
    products:{
      type: Array
    },
    callback: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
    }
  },
  computed:{
    /**
     * If the product item is more than 6 and is odd append first child
     */
    productsData() {
      // if( (this.products.length > 6) && (this.products.length % 2 != 0)){
      //   this.products.push(this.products[0])
      // } 
      return this.products;
    },

  },
  methods: {
     prev() {
      if(this.$refs['cat_slide_' + this.id].$swiper){
        this.$refs['cat_slide_' + this.id].$swiper.slidePrev()
      }
    },

    next() {
      if(this.$refs['cat_slide_' + this.id].$swiper){
        this.$refs['cat_slide_' + this.id].$swiper.slideNext()
      }
    },
  },
}
</script>

